import { GridOptions } from '@ag-grid-community/core';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { WIZ_EVENT_TYPE, VALUE_ENTER, VALUE_ESCAPE, WizDateUtils } from '@wizeoo/akm-core-lib';
import {
  FilterComponent,
  WizAgGrid,
  WizBasePopUp,
  WizDatasource,
  WizAgGridUtils,
  WizEventManager, WizEvent
} from '@wizeoo/akm-component-lib';
import { FIELD_KIND, FeiKeyDef, WizConstants } from '@wizeoo/akm-compute-lib';
import { ColDef } from 'ag-grid-community';

// import { FreeDataVO } from '../../../../../../vo/core/freedata.vo';
// import { FreedataArgsVO } from  '../../../../../../vo/core/freedataargs.vo';
// import { FreedataValueVO } from  '../../../../../../vo/core/freedatavalue.vo';
// import { Model } from '../../../../../../model/model';

  export interface filterPopParams {
    model: any,// Model, pour éviter ref circulaire
    currentValue: string, // la valeur en cours
    fkd: FeiKeyDef,
    callback?: Function
  }


// popUp de sélection dans les éléments de clé des formulaires
@Component({
  selector: 'filter-mass-pop',
  templateUrl: './filter-mass.pop.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterMassPop extends WizBasePopUp {

  // validation sur enter, sortie sur Esc
  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === VALUE_ENTER) {
      this.save();
    }
    if (event.key === VALUE_ESCAPE) {
      this.doCancel();
    }
  }

  gridOptions: GridOptions = {
    // suppressRowClickSelection: true,
    onRowDoubleClicked: (params) => this.onRowDouble(params)
  };

  public currentValue: string; // la valeur en cours
  public fkd: FeiKeyDef;
  public freedata: any; // Model pour éviter ref circulaire;FreeDataVO;
  private model: any; // Model pour éviter ref circulaire;

  private doSaveFlag: boolean = true;

  @ViewChild('agGrid') agGrid: WizAgGrid<any>; // Model pour éviter ref circulaire; <FreedataValueVO>;
  @ViewChild('popFilter', { read: FilterComponent }) popFilter: FilterComponent; // filtre


  public dataDS: WizDatasource<any> = new WizDatasource<any>([]) // Model pour éviter ref circulaire; <FreedataValueVO>([]) // DS de la liste
    .setFilter(this.fdvFilterFunc.bind(this))
    .setSelectionMode('single')
    .build();



  public keyGridColumns: ColDef[] = [];

  constructor(public elementRef: ElementRef, protected cdref: ChangeDetectorRef) {
    super();
  }

  show(): void {
    let params: filterPopParams = this.datas;
    this.model = params.model;
    this.fkd = params.fkd;
    this.currentValue = params.currentValue;
    this.callback = params.callback;

    this.feed();
    this.addListeners();
  }


  // filterFunc de la collection de fdv
  protected fdvFilterFunc(item: any): boolean {
    if(item.deprecated) { // masquer les deprecated
      return false;
    }

    if(!!item.endDate && WizDateUtils.numberToDate(item.endDate) < WizDateUtils.TODAY) { // masquer les deprecated
      return false;
    }

    return this.popFilter.checkVisible(item.argsObjVO);
  }


  /** sur séquence de démarrage, alimentation des listes avec leurs DS */
  public feed(): void {
    let fdvs: any[] = this.model.freedataEngine.getFreedataValuesByLevel(this.fkd.fullCode);
    this.freedata = this.model.freedataEngine.getFreeData(this.fkd.code);
    

    // les colonnes choisies pour l'affichage
    let cols: string[] = [WizConstants.FIELD_SHORT_CODE, WizConstants.FIELD_LABEL]; // si rien de défini, code, label

    this.keyGridColumns = [];
    
    const sortKey: any[] = []; // trier par ordre de colonnes

    cols.forEach( col => {
      const arg: any = this.model.freedataEngine.getArgFromFD(this.fkd.code, col);
      let realField: string = 'argsObjVO' +'.'+ col;
      // TODO rendu des colonnes pour les sous-FD (genre Labs)
      let size: number = !!arg.defaultSize ? arg.defaultSize : 100;
      sortKey.push({property: realField, way: 'asc', numeric: this.model.dataEngine.datakindIsNumeric(arg.dataType)});
      let coldef: any = { headerName: arg.trsLabel, width: size, sortable: true, resizable: true, field: realField };
      if (arg.dataType === FIELD_KIND.BINARY) {
        coldef.cellClass = 'grid-cell-centered';
        coldef.cellRenderer = this.model.gridAccessors.attachmentCellRender;
        coldef.valueFormatter = this.voidFormatter;
        coldef.tooltipField = null;
      } else if (arg.dataType === FIELD_KIND.BOOLEAN) {
        coldef.cellClass = 'cbox-cell';
        coldef.cellClass += ' no-edit';
        coldef.valueFormatter = this.voidFormatter;
        coldef.cellRenderer = WizAgGridUtils.CELL_CHECKBOX_RENDERER;
      }
      this.keyGridColumns.push(coldef);
    });
    this.popFilter.configure(cols, null, null).build();

    this.dataDS.setSource(fdvs);
    this.dataDS.setSortFields(sortKey);
    this.dataDS.refresh();
    
    
    let fdv: any = null;
    if (this.currentValue) {
      fdv = this.dataDS.getItemByKey(this.currentValue);
    }
    this.dataDS.select([fdv]);
  }

  private voidFormatter(val: any): any {
    return val.value;
  }


  /**
   * Refresh du filtre
   * @param event : Evenement de changement dans la zone de filtre
   */
  private refreshFilter(event: WizEvent = null): void {
    this.dataDS.refresh();
  }

  /** mise en place des écouteurs */
  public addListeners(): void {
    // Filtres
    WizEventManager.addListener(this, this.popFilter, WIZ_EVENT_TYPE.FILTER, this.refreshFilter);
  }

  /** double-clic sur une ligne, sélection single auto + dispatch */
  private onRowDouble(params: any): void {
    this.dataDS.select([params.data]);
    this.save();
  }


  /** Sauvegarde */
  public save(): void {
    this.hide();
  }

  /** annulation des modifs */
  public doCancel(): void {
    this.doSaveFlag = false;
    this.hide();
  }

  public onHide() {
    if (this.doSaveFlag) {
      const val: string = this.dataDS.selectedItem ? this.dataDS.selectedItem.code : null;
      this.callback(val);
    }
  }
}
